import React from "react";
import { useSelector } from "react-redux";
import projectDefaultIcon from "../../assets/icons/icon-project.png";
import { Spinner } from "../../components/Loading";
import { useScope } from "../SelectProjectCompanyContainer";
import { isMobile } from "react-device-detect";
import { useOfflineFormProject } from "../../core/utils/hooks/useFormProject";

const SelectCompanyContainer = ({ openCompanyMenu, setOpenCompanyMenu, collapsed }) => {
  const { scope, scopeName, scopeType } = useScope();
  const projects = useSelector((state) => state.app.projects || []);
  const _preloadForm = useOfflineFormProject(scope?.id, scopeType)

  const getCompanies = async () => {
    if (!collapsed) {
      setOpenCompanyMenu(true);
    }
  };

  const getLabelFromType = (type = 'company') => {
    if (type === 'project') return 'PROJETO';
    else if (type === 'company') return 'EMPRESA';
    else if (type === 'organization') return 'ORGANIZAÇÃO';
    else return 'AGRUPADOR';
  };

  return (
    <div className="select-sidebar-container">
      <span className="select-sidebar__label">{getLabelFromType(scopeType)}</span>
      <div className={`select-sidebar__option${!openCompanyMenu ? " select-sidebar__option--project-menu" : ""}`}>
        <div className="select-sidebar__option-content">
          {projects?.length ? (
            <>
              <div
                className="select-sidebar__option-project-info"
                onClick={() => getCompanies()}
                title={`${scopeName}`}
              >
                <div className="select-sidebar__option-project-info-image">
                  <img
                    src={
                      (scope?.image && !scope?.image.includes("https://storage") && scope?.image) ||
                      projectDefaultIcon
                    }
                  />
                </div>
                <div className="select-sidebar__option-project-info-title">
                  {scopeName}
                </div>
              </div>
              <div className="select-sidebar__option-action">
                {openCompanyMenu ? (
                  <button className="close-company-menu" onClick={() => setOpenCompanyMenu(false)}>
                    <i className="fi fi-sr-cross-circle"></i>
                  </button>
                ) : (
                  <button className="open-company-menu" onClick={() => getCompanies()}>
                    <i className="fi fi-rr-caret-right"></i>
                  </button>
                )}
              </div>
            </>
          ) : (
            <Spinner color="primary" size="xsmall" label="Buscando projetos" />
          )}
        </div>
      </div>
    </div>
  );
};




export default SelectCompanyContainer;